import { faWindowClose } from "@jewlr/pro-regular-svg-icons/faWindowClose"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { jewlr_t } from "helpers/application"

const OutOfStockBanner = () => (
  <div className="tablet:w-auto tablet:border-none tablet:-mb-8 tablet:mt-24 mb-10 inline-block w-full rounded-lg border border-[#e6ce8f] bg-[#fff1cc] px-20 py-16">
    <div className="mb-2 flex items-center">
      <FontAwesomeIcon className="mr-8" icon={faWindowClose} />
      <h2 className="text-18 tracking-tigher font-bold">OUT OF STOCK</h2>
    </div>
    <p className="text-14 tracking-tigher ml-24">
      One or more of the items in {jewlr_t("cart")} is no longer available.
    </p>
  </div>
)

export default OutOfStockBanner
